import store from '../redux/store';

export function authHeader() {
    const accessToken = store.getState().auth?.user?.accessToken;
    if (!accessToken) {
        return { Authorization: '' };
    }
    return { Authorization: `Bearer ${accessToken}` };
}